<template>
    <div class="bg-primary">
        <template v-for="(item, index) in items">
            <div class="bg-white w-1px h-15px ml-1 mr-2" v-if="item.type === 'divider'" :key="`divider${index}`"/>
            <menu-item v-else :key="index" v-bind="item"/>
        </template>
    </div>
</template>

<script>

import MenuItem from './MenuItem.vue'

export default {
    components: {
        MenuItem,
    },

    props: {
        editor: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            items: [
                {
                    icon: 'fa-bold',
                    title: 'Bold',
                    action: () => this.editor.chain().focus().toggleBold().run(),
                    isActive: () => this.editor.isActive('bold'),
                },
                {
                    icon: 'fa-italic',
                    title: 'Italic',
                    action: () => this.editor.chain().focus().toggleItalic().run(),
                    isActive: () => this.editor.isActive('italic'),
                },
                {
                    icon: 'fa-strikethrough',
                    title: 'Strike',
                    action: () => this.editor.chain().focus().toggleStrike().run(),
                    isActive: () => this.editor.isActive('strike'),
                },
                {
                    type: 'divider',
                },
                {
                    replaceIcon: 'H1',
                    title: 'Heading 1',
                    action: () => this.editor.chain().focus().toggleHeading({level: 1}).run(),
                    isActive: () => this.editor.isActive('heading', {level: 1}),
                },
                {
                    replaceIcon: 'H2',
                    title: 'Heading 2',
                    action: () => this.editor.chain().focus().toggleHeading({level: 2}).run(),
                    isActive: () => this.editor.isActive('heading', {level: 2}),
                },
                {
                    replaceIcon: 'H3',
                    title: 'Heading 3',
                    action: () => this.editor.chain().focus().toggleHeading({level: 3}).run(),
                    isActive: () => this.editor.isActive('heading', {level: 3}),
                },
                {
                    replaceIcon: 'H4',
                    title: 'Heading 4',
                    action: () => this.editor.chain().focus().toggleHeading({level: 4}).run(),
                    isActive: () => this.editor.isActive('heading', {level: 4}),
                },
                {
                    icon: 'fa-paragraph',
                    title: 'Paragraph',
                    action: () => this.editor.chain().focus().setParagraph().run(),
                    isActive: () => this.editor.isActive('paragraph'),
                },
                {
                    type: 'divider',
                },
                {
                    icon: 'fa-list-ul',
                    title: 'Bullet List',
                    action: () => this.editor.chain().focus().toggleBulletList().run(),
                    isActive: () => this.editor.isActive('bulletList'),
                },
                {
                    icon: 'fa-list-ol',
                    title: 'Ordered List',
                    action: () => this.editor.chain().focus().toggleOrderedList().run(),
                    isActive: () => this.editor.isActive('orderedList'),
                },
                {
                    icon: 'fa-link',
                    title: 'Link',
                    action: () => this.setLink(),
                    isActive: () => this.editor.isActive('link'),
                },
                {
                    icon: 'fa-unlink',
                    title: 'Unlink',
                    action: () => this.editor.chain().focus().unsetLink().run(),
                    isActive: () => this.editor.isActive('unlink'),
                },
            ],
        }
    },

    methods: {
        setLink() {
            const previousUrl = this.editor.getAttributes('link').href
            const url = window.prompt('URL', previousUrl)

            if (url === null) {
                return
            }
            if (url === '') {
                this.editor.chain().focus().extendMarkRange('link').unsetLink().run()

                return
            }

            this.editor.chain().focus().extendMarkRange('link').setLink({href: url}).run()
        },
    },

}
</script>